import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import DepartureView from "./DepartureView";
import DeliveryView from "./DeliveryView";
import TabsNavbar from "../Components/Common/TabsNavBar/TabsNavbar";
import DepotView from "./DepotView";
import TransporterView from "./TransporterView";
import ApprovTabContent from "../Components/Commandes/Approvisionnement/ApprovTabContent";
import AdvancedStock from "../Components/Commandes/AdvancedStock/AdvancedStock";

const LogisticsView = () => {
  const tabs = ["Delivery", "Supplies", "Stock", "Depot", "Transporters"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { user } = useSelector((state) => state.userReducer);
  const userRole = user?.attributes?.userRole;

  return (
    <div className="w100 d-flex flex-column gap-4 h-100">
      {[2, 3]?.includes(userRole) ? (
        <DepartureView />
      ) : [0, 4].includes(userRole) ? (
        <DeliveryView />
      ) : (
        <>
          <TabsNavbar
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            className="gap-5"
          />
          {activeTab === "Depot" && <DepotView />}
          {activeTab === "Transporters" && <TransporterView />}
          {activeTab === "Delivery" && <DepartureView />}
          {activeTab === "Supplies" && (
            <ApprovTabContent activeTab={activeTab} />
          )}
          {activeTab === "Stock" && <AdvancedStock />}
        </>
      )}
    </div>
  );
};

export default LogisticsView;
